<template>
  <div>
    <BaseShowMore collapsable>
      <template v-if="sharedJobs.length">
        <!-- eslint-disable-next-line vue/require-v-for-key -- Baseline eslint ignore please fix if working on this-->
        <div v-for="job in sharedJobs">
          <div class="tw-mb-7 tw-flex tw-justify-between tw-items-start">
            <div class="tw-flex">
              <div class="tw-mr-3">
                <ProfileInfoCard :global-id="job.companyGlobalId">
                  <WdsAvatar :path="getAvatarPath(job.companyPicture, job.companyGlobalId)" />
                </ProfileInfoCard>
              </div>
              <div>
                <a :href="job.route">
                  {{ job.name }}
                </a>
                <div>
                  {{ job.companyDisplayName }}
                </div>
                <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
                <WdsLabel v-if="!job.isAvailable" sm>
                  {{ $t('No longer available') }}
                </WdsLabel>
              </div>
            </div>
            <a
              v-if="job.conversationId"
              data-toggle="tooltip"
              :title="$t('Go to conversation')"
              :href="laravelNamedRoute(namedRoutes.messages.show, { id: job.conversationId })"
            >
              <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
              <WdsButtonGhost>
                <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
                <WdsIcon name="chat" :size="16" />
              </WdsButtonGhost>
            </a>
          </div>
        </div>
      </template>
      <em v-else>
        {{ $t('Here you will be able to see all of the jobs shared with you by your clients.') }}
      </em>
    </BaseShowMore>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { WdsAvatar } from '@worksome/wds-components'
import BaseShowMore from '@/components/BaseShowMore.vue'
import ProfileInfoCard from '@/components/ProfileInfoCard.vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import { getAvatarPath } from '@/utils/avatar'

const props = defineProps({
  sharedJobs: {
    type: Array,
    default: () => [],
  },
})
</script>
